import { render, staticRenderFns } from "./profils.vue?vue&type=template&id=430410fc&"
import script from "./profils.vue?vue&type=script&lang=ts&"
export * from "./profils.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports